import React, { Fragment, useRef } from 'react';
import { translate } from '../../../Services/translation';
import constants from '../../../constants';
import MiniCartProduct from './MiniCartProduct';
import PnIcon from '../../../_PandoNexis/Components/PnIcon';
import CheckoutOrderInfo from '../../../_PandoNexis/Components/Checkout.OrderInfo';
import { useDispatch, useSelector } from 'react-redux';
import { useClickOutside } from 'react-browser-hooks';

const MiniCartExtended = ({
  quantity,
  checkoutUrl,
  showInfo,
  toggle,
  update,
  reloadPayment,
  orderRows,
  pnOrderRows,
  deliveryCost,
  grandTotal,
  orderTotal,
  isInCheckout,
}) => {
  const dispatch = useDispatch();
  const quantityDispatch = (articleNumber, quantity, dispatch) => {
    mapCartToAbort[articleNumber] = new AbortController();
    dispatch(
      update(articleNumber, quantity, mapCartToAbort[articleNumber])
    ).then(() => {
      dispatch(reloadPayment());
    });
  };

  const cartRef = useRef(false);
  const currentOrderRows = pnOrderRows || orderRows;

  const hideCart = () => {
    if (showInfo) {
      toggle();
    }
  };
  useClickOutside(cartRef, { active: showInfo }, hideCart);

  return (
    <div className="cart cart--mini" ref={cartRef}>
      <a
        className="cart__link--block"
        rel="nofollow"
        href="#"
        onClick={(e) => {
          e.preventDefault();
          toggle();
        }}
      >
        <span className="cart__icon-wrapper">
          <PnIcon
            iconName="cart"
            title="cart"
            width="32"
            height="32"
            cssClass=""
          />
          <span className="cart__quantity">{quantity}</span>
        </span>
        <span className="cart__title hide">
          {translate('minicart.checkout')}
        </span>
      </a>
      <div
        className={`cart__dimmer${!showInfo ? ' cart__dimmer--hidden' : ''}`}
        onClick={() => toggle(false)}
      ></div>
      <div
        className={`cart__info-pnextended${
          !showInfo && !isInCheckout ? ' cart__info-pnextended--hidden' : ''
        }${currentOrderRows.length ? '' : ' cart__info-pnextended--empty'}`}
      >
        <header className="cart__info-pnextended-header">
          {!isInCheckout && (
            <div
              className="cart__close-button-extended-container"
              onClick={() => toggle()}
            >
              <PnIcon
                iconName="close"
                title="cart"
                width="16"
                height="16"
                cssClass="cart__close-button-extended"
              />
            </div>
          )}
        </header>
        {currentOrderRows.length ? (
          <Fragment>
            <div className="cart__info-pnextended-heading">
              <h2>{translate('minicartextended.newheading')}</h2>
            </div>
            {showInfo && (
              <div className="cart__info-pnextended-items">
                {currentOrderRows.map((orderRow) => {
                  const { articleNumber, quantity } = orderRow;
                  if (isInCheckout) {
                    return (
                      <MiniCartProduct
                        key={articleNumber}
                        articleNumber={articleNumber}
                        product={orderRow}
                        onCartItemIncrement={() =>
                          update(articleNumber, quantity + 1).then(() =>
                            reloadPayment()
                          )
                        }
                        onCartItemDecrement={() =>
                          update(
                            articleNumber,
                            quantity > 1 ? quantity - 1 : quantity
                          ).then(() => reloadPayment())
                        }
                        onCartItemRemove={() =>
                          update(articleNumber, 0).then(() => reloadPayment())
                        }
                        onUpdate={(articleNo, q) =>
                          update(articleNo, q).then(() => reloadPayment())
                        }
                      />
                    );
                  } else {
                    return (
                      <MiniCartProduct
                        key={articleNumber}
                        product={orderRow}
                        onCartItemIncrement={() =>
                          update(articleNumber, quantity + 1)
                        }
                        onCartItemDecrement={() =>
                          update(
                            articleNumber,
                            quantity > 1 ? quantity - 1 : quantity
                          )
                        }
                        onCartItemRemove={() => update(articleNumber, 0)}
                        onUpdate={(q) => update(articleNumber, q)}
                      />
                    );
                  }
                })}
              </div>
            )}
            <div className="cart__info-pnextended-summary">
              <div className="cart__summary__info-pnextended-row">
                <CheckoutOrderInfo />
                {/*<div className="cart__split-row">*/}
                {/*    <span className="cart__summary-total-text">{translate('checkout.cart.total')}</span>*/}
                {/*    <span className="cart__split-row__total">{orderTotal}</span>*/}
                {/*</div>*/}
              </div>
              <Fragment>
                <a
                  href={checkoutUrl}
                  className="button cart__checkout-button-extended"
                >
                  {translate('minicartextended.tocheckout')}
                </a>
                {constants.paymentMethods && (
                  <div
                    className="cart__payment-methods"
                    dangerouslySetInnerHTML={{
                      __html: constants.paymentMethods,
                    }}
                  ></div>
                )}
              </Fragment>
            </div>
          </Fragment>
        ) : (
          <div className="cart__info-pnextended-empty">
            <h2>{translate('minicartextended.emptyheading')}</h2>
          </div>
        )}
      </div>
    </div>
  );
};

export default MiniCartExtended;
